function getFieldString(field) {
  const type = typeof(field);

  if (type === 'string') {
    return `${field}\n`;
  }
  else if (type === 'object') {
    const fieldName = Object.keys(field)[0];

    let fieldListString = `${fieldName} {\n`;
    for (let i = 0; i < field[fieldName].length; i++) {
      fieldListString += getFieldString(field[fieldName][i]);
    }
    fieldListString += `}\n`;

    return fieldListString;
  }
}

export function getFieldListString(fields) {
  let fieldListString = '';

  for (let field of fields) {
    fieldListString += getFieldString(field);
  }

  return fieldListString;
}

export function getFieldEnumValuesQueryString(fieldName, enumName) {
  return `${fieldName}: __type(name: "${enumName}") {
    options: enumValues {
      value: name
      label: description
    }
  }`;
}